<div [class.override]="storefrontId === 572">
  <h2>Reset your password</h2>
  <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
    <div>
      <p>{{ 'REST-PASSWORD.forgotPassword' | translate }}</p>
      <p>
        {{ 'REST-PASSWORD.enterEmailAddress' | translate }}
      </p>
    </div>
    <div class="reset-form">
      <app-input
        name="Email"
        [control]="resetPasswordForm.controls.email"
        label="Email"
      ></app-input>
      <div class="reset">
        <app-button
          label="{{ 'REST-PASSWORD.sendPasswordResetLink' | translate }}"
          [fullWidth]="true"
          type="submit"
        />
        <app-button
          label="{{ 'COMMON.back' | translate }}"
          [fullWidth]="true"
          buttonStyle="outlined"
          routerLink="/login"
        />
        <app-server-errors-list [errors]="this.serverErrors"></app-server-errors-list>
      </div>
    </div>
  </form>
</div>
